import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { ConfigurationService } from '../services/configuration.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  role: string;

  constructor(
    private auth: AuthService,
    private router: Router,
    private configurationService: ConfigurationService
  ) { }

  ngOnInit() {
    //FIXME: do not call this here, call user profile or another thing to validate the session
    this.refreshConfiguration();
    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.refreshConfiguration();
        } else {
          this.role = '';
        }
        // this.dialog.open(MessageBoxDialog, {data: {message: "No se pudo conectar con el servidor, Problemas de conexión con internet", success:true, showIcon:true}});
      }
    );
  }

  refreshConfiguration() {
    if (localStorage.getItem('role')) {
      this.role = localStorage.getItem('role');
    } else {
      this.role = '';
    }
    if (this.role === 'docchecker') {
      this.router.navigate(['checkdoclist']);
    }
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/dashboard/dashboard.component.ts